import { render, staticRenderFns } from "./CellCompanyPosition.vue?vue&type=template&id=4f6d8a40&scoped=true&"
import script from "./CellCompanyPosition.vue?vue&type=script&lang=js&"
export * from "./CellCompanyPosition.vue?vue&type=script&lang=js&"
import style0 from "./CellCompanyPosition.vue?vue&type=style&index=0&id=4f6d8a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d8a40",
  null
  
)

export default component.exports